import React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import GridPaper from "../ContentBox/GridPaper";
import {TableContainer} from "@mui/material";

type Props = {
  children: React.ReactNode
  displayTitle?: boolean
}

export default function OverviewTable({children, displayTitle = true}: Props) {
  return (
      <GridPaper title={displayTitle ? "Überblick" : undefined}>
        <TableContainer>
          <Table sx={{minWidth: 650, overflowX: "scroll"}} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Erhebungsform</TableCell>
                <TableCell>Zieldimension</TableCell>
                <TableCell>Rater</TableCell>
                <TableCell>Altersrange</TableCell>
                <TableCell>Items</TableCell>
                <TableCell>Bearbeitungsdauer</TableCell>
                <TableCell>Publikation</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow
                  sx={{'&:last-child td, &:last-child th': {border: 0}, verticalAlign: "top"}}>
                {children}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </GridPaper>
  );
}
